import { convertFirestampToISOString } from '@/utils/constants';
import { normalizeTaskTimestamp } from '@/utils/kanbanDealSync';
import { createDisplayFieldPicker } from '@/utils/rowCacheSync';

/** Firestore-backed pipeline rows share getDealRow cache (deals, debtors, claims/tickets). */
export const usesDealRowCache = (objectType) =>
	objectType === 'deal' || objectType === 'debtor' || objectType === 'ticket';

/**
 * Picks kanban card / pipeline list grid display fields from a cached getDealRow entry.
 * Used when merging search hits with RTK Query cache (read-only, no fetch).
 */
export const pickPipelineDisplayFieldsFromDealRow = createDisplayFieldPicker({
	dealName: 'present',
	dealStage: 'present',
	dealAmount: 'present',
	claimId: 'present',
	clientName: 'present',
	effectiveDate: 'present',
	status: 'nullable',
	dateClosed: 'nullable',
	ownerId: 'truthy',
	ownerDocId: 'truthy',
	clientOwnerId: 'truthy',
	clientOwnerDocId: 'truthy',
	renewalDate: 'present',
	nextTaskDate: { transform: normalizeTaskTimestamp },
	estimatedCloseDate: {
		transform: (value) => convertFirestampToISOString(value) ?? value,
	},
	automationEnabled: { rule: 'nullable', transform: Boolean },
	informedConsentStatus: 'present',
	informedConsentDate: {
		rule: 'nullable',
		transform: (value) => convertFirestampToISOString(value) ?? value,
	},
	informedConsentDateExpiry: {
		rule: 'nullable',
		transform: (value) => convertFirestampToISOString(value) ?? value,
	},
});
